<div class="app-wrapper d-flex flex-column min-vh-100">
  <app-header [lang]="language"></app-header>

  <div class="flex-grow-1" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
    <router-outlet></router-outlet>
  </div>

  <app-footer [lang]="language"></app-footer>
</div>
